module.exports = __webpack_public_path__ + "img/coach_bg.2c6dc567.png";